import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import Home from '../pages/Home';
import Profile from '../pages/Profile';

const AuthenticatedRoutes: React.FC = () => (
  <BrowserRouter>
    <Route exact path="/" component={Home} />
    <Route path="/profile" component={Profile} />
  </BrowserRouter>
);

export default AuthenticatedRoutes;
